var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "leaves_top" }),
      _vm._v(" "),
      _c("HeaderMenu_Admin"),
      _vm._v(" "),
      _c("LateralMenu_Admin"),
      _vm._v(" "),
      _c("div", { attrs: { id: "admin" } }, [
        _c(
          "div",
          { staticClass: "calendrier-container content" },
          [
            _c(
              "div",
              { staticClass: "admin-tools header" },
              [
                _c("router-link", {
                  attrs: { to: "/admin/logout" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ href }) {
                        return [
                          _c("button", { attrs: { href: href } }, [
                            _vm._v("Déconnexion"),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v("Enregistrer une réservation"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-tools header" }, [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked("le-tombeau-de-siptah")
                    },
                  },
                },
                [_vm._v("Le tombeau"), _c("br"), _vm._v("de Siptah")]
              ),
              _vm._v("\n                 \n                "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked("le-secret-de-mayoko")
                    },
                  },
                },
                [_vm._v("Le secret"), _c("br"), _vm._v("de Mayoko")]
              ),
              _vm._v("\n                 \n                "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked(
                        "les-gardiens-de-vichama"
                      )
                    },
                  },
                },
                [_vm._v("Les gardiens"), _c("br"), _vm._v("de Vichama")]
              ),
              _vm._v("\n                 \n                "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked(
                        "le-talisman-des-titans"
                      )
                    },
                  },
                },
                [_vm._v("Le talisman"), _c("br"), _vm._v("des Titans")]
              ),
              _vm._v("\n                 \n                "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked("la-legende-d-ishtar")
                    },
                  },
                },
                [_vm._v("La légende"), _c("br"), _vm._v("d'Ishtar")]
              ),
              _vm._v("\n                 \n                "),
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addReservation_clicked("nestor-bomb-simulator")
                    },
                  },
                },
                [_vm._v("NESTOR"), _c("br"), _vm._v("Bomb Simulator")]
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "title" }, [
              _vm._v("Horaires d'ouverture"),
            ]),
            _vm._v(" "),
            _c("Calendrier", {
              ref: "calendrierComponent",
              attrs: { view_isAdmin: true },
              on: {
                calendrier_daySelected: _vm.calendrier_daySelected,
                calendrier_dayUnselected: _vm.calendrier_dayUnselected,
              },
            }),
            _vm._v(" "),
            _vm.creneaux_jour && _vm.reservations
              ? _c("div", { attrs: { id: "planning" } }, [
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(
                      "\n                    Horaires du " +
                        _vm._s(_vm.calendarDay) +
                        " " +
                        _vm._s(_vm.calendarLabel) +
                        "\n                     "
                    ),
                    _c("i", {
                      staticClass: "fa-solid fa-calendar-check",
                      on: {
                        click: function ($event) {
                          return _vm.creneauxSetAvailability_clickAll(true)
                        },
                      },
                    }),
                    _vm._v("\n                     "),
                    _c("i", {
                      staticClass: "fa-solid fa-calendar-xmark",
                      on: {
                        click: function ($event) {
                          return _vm.creneauxSetAvailability_clickAll(false)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "creneaux_infos responsive-block mw960" },
                    [
                      _vm._v(
                        "Nombre de créneaux réservés : " +
                          _vm._s(_vm.creneaux_nb_rooms_reservation) +
                          " / " +
                          _vm._s(_vm.creneaux_nb_rooms_available)
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "creneaux-rooms" }, [
                    _c(
                      "div",
                      { staticClass: "creneaux" },
                      _vm._l(
                        _vm.creneaux_sets_keys,
                        function (creneaux_set_key) {
                          return _c("div", [
                            _c(
                              "span",
                              { staticClass: "header-top" },
                              [
                                _vm.creneauAlloc_processStep == "requesting" &&
                                _vm.creneauAlloc_processId == creneaux_set_key
                                  ? [
                                      _vm._v(
                                        "\n                                    Dispo.\n                                     "
                                      ),
                                      _c("Loader_Mini"),
                                    ]
                                  : _vm.creneauAlloc_processStep == "done" &&
                                    _vm.creneauAlloc_processId ==
                                      creneaux_set_key
                                  ? [
                                      _vm._v(
                                        "\n                                    Dispo.\n                                     "
                                      ),
                                      _c("Checkmark"),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                    Dispo.\n                                     "
                                      ),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.creneaux_sets[
                                                creneaux_set_key
                                              ].game_master_nb,
                                            expression:
                                              "creneaux_sets[creneaux_set_key].game_master_nb",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        domProps: {
                                          value:
                                            _vm.creneaux_sets[creneaux_set_key]
                                              .game_master_nb,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.update_creneauxSetAlloc(
                                              creneaux_set_key
                                            )
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.creneaux_sets[
                                                creneaux_set_key
                                              ],
                                              "game_master_nb",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ],
                              ],
                              2
                            ),
                          ])
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "creneaux" },
                      _vm._l(
                        _vm.creneaux_sets_keys,
                        function (creneaux_set_key) {
                          return _c("div", [
                            _vm.creneauxSetAvailability_processId ==
                            creneaux_set_key
                              ? _c(
                                  "span",
                                  { staticClass: "header-subtop" },
                                  [_c("Loader_Mini")],
                                  1
                                )
                              : _vm.checkCreneauxSet_availability(
                                  creneaux_set_key
                                ) === false
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "header-subtop",
                                    on: {
                                      click: function ($event) {
                                        return _vm.creneauxSetAvailability_click(
                                          creneaux_set_key,
                                          true
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Ouvrir tout")]
                                )
                              : _vm.checkCreneauxSet_availability(
                                  creneaux_set_key
                                ) === true
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "header-subtop",
                                    on: {
                                      click: function ($event) {
                                        return _vm.creneauxSetAvailability_click(
                                          creneaux_set_key,
                                          false
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Fermer tout")]
                                )
                              : _vm._e(),
                          ])
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "creneaux-rooms normal-block mw960" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_1" in
                            _vm.creneaux_jour[creneau_key].availability ||
                            "room_2" in
                              _vm.creneaux_jour[creneau_key].availability
                            ? _c("div", [
                                _c("span", { staticClass: "header-top" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.creneaux_jour[creneau_key].label
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      1
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        1
                                      ),
                                    },
                                  },
                                  [
                                    _vm.checkGameModeHighlight(
                                      "decouverte",
                                      creneau_key,
                                      1
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-decouverte-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm.checkGameModeHighlight(
                                          "confirme",
                                          creneau_key,
                                          1
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-confirme-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_1"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_1"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            1
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          1
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_1"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    1
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      2
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        2
                                      ),
                                    },
                                  },
                                  [
                                    _vm.checkGameModeHighlight(
                                      "decouverte",
                                      creneau_key,
                                      2
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-decouverte-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm.checkGameModeHighlight(
                                          "confirme",
                                          creneau_key,
                                          2
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-confirme-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_2"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    2
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_2"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    2
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            2
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_2"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    2
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      5
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        5
                                      ),
                                    },
                                  },
                                  [
                                    _vm.checkGameModeHighlight(
                                      "decouverte",
                                      creneau_key,
                                      5
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-decouverte-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm.checkGameModeHighlight(
                                          "confirme",
                                          creneau_key,
                                          5
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-confirme-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.getNumeroEpisodeHighlight(
                                            creneau_key
                                          ),
                                      },
                                      [_vm._v(" ")]
                                    ),
                                    _vm._v(" "),
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_5"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    5
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_5"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    5
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            5
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          5
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          5
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_5"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    5
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "creneaux-rooms responsive-block mw960" },
                    [
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_1" in
                            _vm.creneaux_jour[creneau_key].availability ||
                            "room_2" in
                              _vm.creneaux_jour[creneau_key].availability ||
                            "room_5" in
                              _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c("span", { staticClass: "header-top" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.creneaux_jour[creneau_key].label
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_1" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        1
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            1
                                          ),
                                      },
                                    },
                                    [
                                      _vm.checkGameModeHighlight(
                                        "decouverte",
                                        creneau_key,
                                        1
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-decouverte-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm.checkGameModeHighlight(
                                            "confirme",
                                            creneau_key,
                                            1
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-confirme-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_1"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      1
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_1"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      1
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              1
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_1"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      1
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_2" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        2
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            2
                                          ),
                                      },
                                    },
                                    [
                                      _vm.checkGameModeHighlight(
                                        "decouverte",
                                        creneau_key,
                                        2
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-decouverte-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm.checkGameModeHighlight(
                                            "confirme",
                                            creneau_key,
                                            2
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-confirme-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_2"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_2"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              2
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            2
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            2
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_2"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_5" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        5
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            5
                                          ),
                                      },
                                    },
                                    [
                                      _vm.checkGameModeHighlight(
                                        "decouverte",
                                        creneau_key,
                                        5
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-decouverte-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm.checkGameModeHighlight(
                                            "confirme",
                                            creneau_key,
                                            5
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-confirme-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class:
                                            _vm.getNumeroEpisodeHighlight(
                                              creneau_key
                                            ),
                                        },
                                        [_vm._v(" ")]
                                      ),
                                      _vm._v(" "),
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_5"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      5
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_5"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      5
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              5
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            5
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            5
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_5"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      5
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "creneaux-rooms normal-block mw960" },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_3" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c("div", [
                                _c("span", { staticClass: "header-top" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.creneaux_jour[creneau_key].label
                                      ) +
                                      "\n                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      3
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        3
                                      ),
                                    },
                                  },
                                  [
                                    _vm.checkGameModeHighlight(
                                      "decouverte",
                                      creneau_key,
                                      3
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-decouverte-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm.checkGameModeHighlight(
                                          "confirme",
                                          creneau_key,
                                          3
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-confirme-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_3"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    3
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_3"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    3
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            3
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_3"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    3
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_4" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      4
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        4
                                      ),
                                    },
                                  },
                                  [
                                    _vm.checkGameModeHighlight(
                                      "decouverte",
                                      creneau_key,
                                      4
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-decouverte-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm.checkGameModeHighlight(
                                          "confirme",
                                          creneau_key,
                                          4
                                        )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mode-confirme-highlight",
                                          },
                                          [_vm._v(" ")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_4"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    4
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_4"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    4
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            4
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          4
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          4
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_4"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    4
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_6" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "creneau",
                                    class: _vm.creneauRoom_bindClass(
                                      creneau_key,
                                      6
                                    ),
                                    attrs: {
                                      title: _vm.creneauRoom_debugAvailableType(
                                        creneau_key,
                                        6
                                      ),
                                    },
                                  },
                                  [
                                    _vm.creneaux_jour[creneau_key].reservations[
                                      "room_6"
                                    ]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    6
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Réservé")]
                                          ),
                                        ]
                                      : _vm.creneaux_jour[creneau_key]
                                          .availability["room_6"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    6
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Ouv.")]
                                          ),
                                          _vm._v(" "),
                                          _vm.creneauRoom_checkExceptions(
                                            creneau_key,
                                            6
                                          )
                                            ? [
                                                _vm._v(
                                                  "  \n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          6
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ☎")]
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                         "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.creneauRoomAvailabilityException_clicked(
                                                          creneau_key,
                                                          6
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" ＠")]
                                                ),
                                              ],
                                        ]
                                      : !_vm.creneaux_jour[creneau_key]
                                          .availability["room_6"]
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.creneauRoom_clicked(
                                                    creneau_key,
                                                    6
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Fermé")]
                                          ),
                                        ]
                                      : [_vm._v(" ")],
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e()
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "creneaux-rooms responsive-block mw960" },
                    [
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_3" in
                            _vm.creneaux_jour[creneau_key].availability ||
                            "room_4" in
                              _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c("span", { staticClass: "header-top" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.creneaux_jour[creneau_key].label
                                        ) +
                                        "\n                            "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_3" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        3
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            3
                                          ),
                                      },
                                    },
                                    [
                                      _vm.checkGameModeHighlight(
                                        "decouverte",
                                        creneau_key,
                                        3
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-decouverte-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm.checkGameModeHighlight(
                                            "confirme",
                                            creneau_key,
                                            3
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-confirme-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_3"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      3
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_3"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      3
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              3
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            3
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            3
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_3"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      3
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_4" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        4
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            4
                                          ),
                                      },
                                    },
                                    [
                                      _vm.checkGameModeHighlight(
                                        "decouverte",
                                        creneau_key,
                                        4
                                      )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-decouverte-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm.checkGameModeHighlight(
                                            "confirme",
                                            creneau_key,
                                            4
                                          )
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mode-confirme-highlight",
                                            },
                                            [_vm._v(" ")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_4"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      4
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_4"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      4
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              4
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            4
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            4
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_4"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      4
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm._m(9),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "creneaux" },
                        _vm._l(_vm.creneaux_keys, function (creneau_key) {
                          return "room_6" in
                            _vm.creneaux_jour[creneau_key].availability
                            ? _c(
                                "div",
                                {
                                  class:
                                    _vm.creneauRoom_Container_bindClass(
                                      creneau_key
                                    ),
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "creneau",
                                      class: _vm.creneauRoom_bindClass(
                                        creneau_key,
                                        6
                                      ),
                                      attrs: {
                                        title:
                                          _vm.creneauRoom_debugAvailableType(
                                            creneau_key,
                                            6
                                          ),
                                      },
                                    },
                                    [
                                      _vm.creneaux_jour[creneau_key]
                                        .reservations["room_6"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      6
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Réservé")]
                                            ),
                                          ]
                                        : _vm.creneaux_jour[creneau_key]
                                            .availability["room_6"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      6
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Ouv.")]
                                            ),
                                            _vm._v(" "),
                                            _vm.creneauRoom_checkExceptions(
                                              creneau_key,
                                              6
                                            )
                                              ? [
                                                  _vm._v(
                                                    "  \n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            6
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ☎")]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                         "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.creneauRoomAvailabilityException_clicked(
                                                            creneau_key,
                                                            6
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" ＠")]
                                                  ),
                                                ],
                                          ]
                                        : !_vm.creneaux_jour[creneau_key]
                                            .availability["room_6"]
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.creneauRoom_clicked(
                                                      creneau_key,
                                                      6
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("Fermé")]
                                            ),
                                          ]
                                        : [_vm._v(" ")],
                                    ],
                                    2
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              : _c("div", { staticClass: "calendrier-error" }, [
                  _vm._v(
                    "\n                Cliquez sur une date dans le calendrier pour afficher\n                "
                  ),
                  _c("br"),
                  _vm._v(
                    "l'organisation des créneaux et les actions contextuelles.\n            "
                  ),
                ]),
            _vm._v(" "),
            _vm.creneaux_jour
              ? _c("span", { staticClass: "title" }, [_vm._v("Outils")])
              : _vm._e(),
            _vm._v(" "),
            _vm.creneaux_jour
              ? _c("div", { staticClass: "admin-tools footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "feuille-de-caisse",
                      on: { click: _vm.feuilleCaisse_clicked },
                    },
                    [_vm._v("Feuille de caisse")]
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.creneaux_jour
          ? _c("div", { staticClass: "reservations-container content" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  "Réservations du " +
                    _vm._s(_vm.calendarDay) +
                    " " +
                    _vm._s(_vm.calendarLabel)
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "liste-reservations" } },
                [
                  _vm._l(_vm.reservations, function (reservation) {
                    return _vm._l(reservation.scenarios, function (scenario) {
                      return _c("div", [
                        _c("span", [_vm._v(_vm._s(scenario.creneau_label))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scenario.room_label))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(reservation.first_name) +
                              " " +
                              _vm._s(reservation.last_name)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(reservation.team_name))]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(scenario.composition) + " "),
                          _c("i", { staticClass: "fa fa-people-group" }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            reservation.language != "FR"
                              ? [_vm._v(_vm._s(reservation.language))]
                              : [_vm._v(" ")],
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("i", {
                          class: _vm.btnThanksEmail_bindClass(reservation),
                          on: {
                            click: function ($event) {
                              return _vm.btnThanksEmail_onClick(reservation)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          class:
                            _vm.btnReservationComment_bindClass(reservation),
                          on: {
                            click: function ($event) {
                              return _vm.btnReservationComment_onClick(
                                reservation,
                                scenario
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "btn-closure",
                          on: {
                            click: function ($event) {
                              return _vm.btnClosure_onClick(reservation)
                            },
                          },
                        }),
                      ])
                    })
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _c("Reservation", {
        ref: "reservationPopin",
        attrs: { view_paymentDelayed: true },
      }),
      _vm._v(" "),
      _c("ReservationComment", { ref: "reservationCommentPopin" }),
      _vm._v(" "),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Siptah")]),
      _vm._v(" "),
      _c("span", [_vm._v("Mayoko")]),
      _vm._v(" "),
      _c("span", [_vm._v("Ishtar")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Siptah")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Mayoko")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Ishtar")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Vichama")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Talisman")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("NESTOR")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Vichama")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("Talisman")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-left" }, [
      _c("span", [_vm._v("NESTOR")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "leaves_sides" } }, [
      _c("div", { staticClass: "left" }),
      _vm._v(" "),
      _c("div", { staticClass: "right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }